import type { MouseEvent } from 'react';

import type { NavigationBarProps } from 'components/navigation-bar/navigation-bar';

import { createLocale } from 'locales';

const localize = createLocale('freelancerAvailableJobsLocales');

const getLinks = (
  isVerified: boolean,
  selectedLink?: string,
): NavigationBarProps => {
  let navigationBar: NavigationBarProps = {} as NavigationBarProps;
  if (isVerified)
    navigationBar = {
      links: [
        {
          id: 'home',
          isSelected: false,
          link: '/freelancer/',
          title: localize('home'),
        },
        {
          id: 'toCallToAction',
          isSelected: false,
          link: '/freelancer/ads/all/',
          title: localize('toCallToAction'),
        },
        {
          id: 'assignements',
          isSelected: false,
          link: '/freelancer/jobs/week/',
          title: localize('assignments'),
        },
        {
          id: 'availability',
          isSelected: false,
          link: '/freelancer/availability/',
          title: localize('availability'),
        },
        {
          id: 'invoices',
          isSelected: false,
          link: '/freelancer/invoice/open/',
          title: localize('invoices'),
        },
        {
          id: 'toInvite',
          isSelected: false,
          link: '/freelancer/invite/',
          title: localize('toInvite'),
        },
        {
          id: 'settings',
          isSelected: false,
          link: '/freelancer/settings/',
          title: localize('settings'),
        },
        {
          id: 'toAsk',
          isSelected: false,
          link: `${process.env.REACT_APP_MARKETING_BASE_URL}/veelgestelde-vragen`,
          onClick: (evt: MouseEvent<HTMLAnchorElement>) => {
            evt.preventDefault();
            window.open(
              `${process.env.REACT_APP_MARKETING_BASE_URL}/veelgestelde-vragen`,
              '_blank',
            );
          },
          title: localize('toAsk'),
        },
        {
          id: 'logout',
          isSelected: false,
          link: '/login/',
          onClick: async (evt: MouseEvent<HTMLAnchorElement>) => {
            evt.preventDefault();
            await fetch('/logout/', {
              credentials: 'same-origin',
            });
            window.location.reload();
          },
          title: localize('logout'),
        },
      ],
      variant: 'neutral',
    };
  else
    navigationBar = {
      links: [
        {
          id: 'home',
          isSelected: false,
          link: '/freelancer/',
          title: localize('home'),
        },
        {
          id: 'toCallToAction',
          isSelected: false,
          link: '/freelancer/ads/example/',
          title: localize('toCallToAction'),
        },

        {
          id: 'toInvite',
          isSelected: false,
          link: '/freelancer/invite/',
          title: localize('toInvite'),
        },
        {
          id: 'settings',
          isSelected: false,
          link: '/freelancer/settings/',
          title: localize('settings'),
        },
        {
          id: 'toAsk',
          isSelected: false,
          link: `${process.env.REACT_APP_MARKETING_BASE_URL}/veelgestelde-vragen`,
          onClick: (evt: MouseEvent<HTMLAnchorElement>) => {
            evt.preventDefault();
            window.open(
              `${process.env.REACT_APP_MARKETING_BASE_URL}/veelgestelde-vragen`,
              '_blank',
            );
          },
          title: localize('toAsk'),
        },
        {
          id: 'logout',
          isSelected: false,
          link: '/login/',
          onClick: async (evt: MouseEvent<HTMLAnchorElement>) => {
            evt.preventDefault();
            await fetch('/logout/', {
              credentials: 'same-origin',
            });
            window.location.reload();
          },
          title: localize('logout'),
        },
      ],
      variant: 'neutral',
    };

  if (selectedLink) {
    const selectedLinkIndex = navigationBar.links.findIndex(
      (link) => link.id === selectedLink,
    );

    navigationBar.links[selectedLinkIndex].isSelected = true;
  }

  return navigationBar;
};

export default getLinks;
